export default "__VITE_ASSET__CXZfjb78__"